export default "__VITE_ASSET__B1a4_j_G__"